import { createEntityAdapter } from '@ngrx/entity';
import { ConversationToastMessage } from '../models/conversation-toast-message.model';

function sortByTimestampDesc(a: ConversationToastMessage, b: ConversationToastMessage): number {
  return b.timestamp - a.timestamp;
}

export const conversationToastMessageAdapter =  createEntityAdapter<ConversationToastMessage>({
  selectId: toastMessage => toastMessage.id,
  sortComparer: sortByTimestampDesc
});
